import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);

export const pick = (lang, item, field) =>
    (lang === "en" && item.en && item.en[field] !== undefined ? item.en[field] : item[field]);

export const UI = {
    it: {
        nav: { produzioni: "Produzioni", chiSiamo: "Chi Siamo", team: "Team", stampa: "News", contatti: "Contatti", cta: "Parliamone" },
        hero: {
            eyebrow: "Produzione cinematografica — Roma / Milano",
            l1: "Diamo forma",
            l2a: "al",
            l2b: "cinema",
            l3: "di domani.",
            tagline:
                "Cinema d'autore, docufilm ed esperienze visive premium. Dal trattamento al final cut, costruiamo storie che restano.",
            cta1: "Scopri le nostre produzioni",
            cta2: "Parliamone",
            scroll: "Scorri",
            side: "Red Private Srl — Roma",
        },
        produzioni: {
            label: "Portfolio",
            title: "Le nostre produzioni",
            sub: "Una selezione curata dei lavori che meglio raccontano chi siamo: pochi progetti, scelti, realizzati con cura ossessiva.",
            ruolo: "Il nostro ruolo",
            close: "Chiudi dettaglio",
            prev: "Immagine precedente",
            next: "Immagine successiva",
            goTo: "Vai all'immagine",
        },
        chisiamo: {
            label: "Chi siamo",
            title: "Storie italiane, respiro internazionale.",
            p1: "RED PRIVATE è una società di produzione cinematografica con sede a Roma. Portiamo sul grande schermo storie che contano: dal primo film dedicato all'universo di Liberato al docufilm su Marco Belinelli, dall'esordio alla regia di Fortunato Cerlino con AVEMMARIA alla produzione esecutiva in Italia di Maserati: The Brothers.",
            p2: "La nostra missione: produrre opere capaci di reggere il confronto con il cinema internazionale, attrarre investimenti esteri di rilievo e contribuire allo sviluppo industriale e culturale del territorio.",
            valori: [
                { titolo: "Sguardo d'autore", testo: "Ogni progetto nasce da una visione forte, mai da un format." },
                { titolo: "Ossessione per il dettaglio", testo: "Dalla sceneggiatura all'output finale, nulla è lasciato al caso." },
                { titolo: "Respiro internazionale", testo: "Storie italiane capaci di attrarre cast, capitali e produzioni da tutto il mondo." },
            ],
            caption: "Sul set — Maserati: The Brothers, Studios De Paolis",
        },
        team: {
            label: "Le persone",
            title: "Il nostro team",
            sub: "La squadra che guida ogni produzione: dalla strategia finanziaria ai partner commerciali, fino all'organizzazione del set.",
        },
        stampa: {
            label: "News · Ufficio Stampa",
            title: "Ufficio stampa",
            sub: "Comunicati, materiali ufficiali e contatti dedicati per giornalisti e media.",
            kitTitle: "Press Kit RED PRIVATE",
            kitText: "Profilo societario, produzioni in evidenza e contatti in un unico documento PDF.",
            kitBtn: "Scarica il press kit",
            contactTitle: "Contatto stampa",
            contactText: "Per interviste, materiali fotografici e richieste media scrivi al nostro ufficio stampa.",
        },
        contatti: {
            label: "Contatti",
            title: "Raccontaci il tuo prossimo progetto.",
            sub: "Film, docufilm o co-produzioni: ogni collaborazione inizia da una conversazione.",
            sede: "Sede",
            email: "Email",
            nome: "Nome e cognome",
            tipo: "Tipo di richiesta",
            messaggio: "Messaggio",
            phNome: "Mario Bianchi",
            phMsg: "Raccontaci in poche righe il progetto, le tempistiche e il budget indicativo…",
            submit: "Invia la richiesta",
            sending: "Invio in corso…",
            successTitle: "Messaggio ricevuto.",
            successText: "Grazie per averci scritto. Un producer del nostro team ti ricontatterà entro 24 ore lavorative.",
            successBtn: "Invia un altro messaggio",
            toastOk: "Messaggio inviato. Ti risponderemo entro 24 ore lavorative.",
            toastErr: "Qualcosa è andato storto. Riprova o scrivici a info@redpvt.com",
        },
        footer: {
            tagline: "Società di produzione cinematografica. Diamo forma al cinema di domani.",
            nav: "Navigazione",
            contatti: "Contatti",
            rights: "© 2026 RED PRIVATE SRL — P.IVA 11746930962 · Tutti i diritti riservati",
            city: "Roma",
        },
    },
    en: {
        nav: { produzioni: "Productions", chiSiamo: "About", team: "Team", stampa: "Press", contatti: "Contact", cta: "Let's talk" },
        hero: {
            eyebrow: "Film production — Rome / Milan",
            l1: "We shape",
            l2a: "the",
            l2b: "cinema",
            l3: "of tomorrow.",
            tagline:
                "Arthouse cinema, documentary films and premium visual experiences. From treatment to final cut, we build stories that last.",
            cta1: "Explore our productions",
            cta2: "Let's talk",
            scroll: "Scroll",
            side: "Red Private Srl — Rome",
        },
        produzioni: {
            label: "Portfolio",
            title: "Our productions",
            sub: "A curated selection of the works that best tell who we are: a few chosen projects, crafted with obsessive care.",
            ruolo: "Our role",
            close: "Close details",
            prev: "Previous image",
            next: "Next image",
            goTo: "Go to image",
        },
        chisiamo: {
            label: "About us",
            title: "Italian stories, international scope.",
            p1: "RED PRIVATE is a film production company based in Rome. We bring stories that matter to the big screen: from the first film dedicated to Liberato's universe to the docufilm on Marco Belinelli, from Fortunato Cerlino's directorial debut AVEMMARIA to the Italian executive production of Maserati: The Brothers.",
            p2: "Our mission: to produce works that stand up to international cinema, attract significant foreign investment and contribute to the industrial and cultural development of our territory.",
            valori: [
                { titolo: "An auteur's eye", testo: "Every project is born from a strong vision, never from a format." },
                { titolo: "Obsession with detail", testo: "From screenplay to final mix: nothing is left to chance." },
                { titolo: "International scope", testo: "Italian stories able to attract cast, capital and productions from all over the world." },
            ],
            caption: "On set — Maserati: The Brothers, Studios De Paolis",
        },
        team: {
            label: "The people",
            title: "Our team",
            sub: "The team leading every production: from financial strategy to commercial partners, to set organization.",
        },
        stampa: {
            label: "News · Press Office",
            title: "Press office",
            sub: "Press releases, official materials and dedicated contacts for journalists and media.",
            kitTitle: "RED PRIVATE Press Kit",
            kitText: "Company profile, featured productions and contacts in a single PDF document.",
            kitBtn: "Download press kit",
            contactTitle: "Press contact",
            contactText: "For interviews, photographic materials and media enquiries, write to our press office.",
        },
        contatti: {
            label: "Contact",
            title: "Tell us about your next project.",
            sub: "Films, documentaries or co-productions: every collaboration starts with a conversation.",
            sede: "Office",
            email: "Email",
            nome: "Full name",
            tipo: "Request type",
            messaggio: "Message",
            phNome: "John Smith",
            phMsg: "Tell us briefly about the project, timeline and indicative budget…",
            submit: "Send request",
            sending: "Sending…",
            successTitle: "Message received.",
            successText: "Thank you for reaching out. A producer from our team will get back to you within 24 working hours.",
            successBtn: "Send another message",
            toastOk: "Message sent. We'll reply within 24 working hours.",
            toastErr: "Something went wrong. Please try again or write to info@redpvt.com",
        },
        footer: {
            tagline: "Film production company. We shape the cinema of tomorrow.",
            nav: "Navigation",
            contatti: "Contact",
            rights: "© 2026 RED PRIVATE SRL — VAT 11746930962 · All rights reserved",
            city: "Rome",
        },
    },
};

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("rp-lang") || "it");

    useEffect(() => {
        localStorage.setItem("rp-lang", lang);
        document.documentElement.lang = lang;
        document.title =
            lang === "en"
                ? "RED PRIVATE SRL | Film Production Company"
                : "RED PRIVATE SRL | Produzione Cinematografica Italiana";
    }, [lang]);

    return (
        <LangContext.Provider value={{ lang, setLang, ui: UI[lang] }}>
            {children}
        </LangContext.Provider>
    );
}

export const useLang = () => useContext(LangContext);
